<template>
  <v-navigation-drawer v-model="onDrawer" app fixed temporary>
    <v-list nav dense>
      <v-list-item-group active-class="purple--text text--accent-4">
        <v-list-item :to="{ path: '/', hash: 'beranda' }">
          <v-list-item-title>
            <span class="subtitle">Beranda</span>
          </v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ path: '/', hash: 'keunggulan' }">
          <v-list-item-title>
            <span class="subtitle">Keunggulan</span>
          </v-list-item-title>
        </v-list-item>

        <!-- <v-list-item :to="{ path: '/', hash: 'konten' }">
          <v-list-item-title>
            <span class="subtitle">Konten</span>
          </v-list-item-title>
        </v-list-item> -->

        <v-list-item :to="{ path: '/', hash: 'fitur' }">
          <v-list-item-title>
            <span class="subtitle">Fitur</span>
          </v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ path: '/', hash: 'course' }">
          <v-list-item-title>
            <span class="subtitle">Course</span>
          </v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ path: '/', hash: 'kontak' }">
          <v-list-item-title>
            <span class="subtitle">Kontak</span>
          </v-list-item-title>
        </v-list-item>

                    <v-btn @click="toSIM()"
                  class="elevation-11 rounded-pill text-capitalize indigo--text text--darken-4 amber darken-1">
                        Masuk 
                    </v-btn>

        
        <!-- <v-list-item :to="{ path: '/', hash: 'aktivasisiswa' }" @click="aktivasiSiswa">
          <v-list-item-title>Aktivasi Siswa</v-list-item-title>
        </v-list-item> -->
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { SIM } from '@/const'
export default {
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    onDrawer: false,
  }),
  methods: {
    toSIM(){
           window.open(SIM, "_blank");
        },
    aktivasiInstansi() {
      window.open(SIM + '#/aktivasi-instansi', '_blank')
    },
    aktivasiSiswa() {
      window.open(SIM + '#/aktivasi-akun', '_blank')
    },
  },
  watch: {
    drawer() {
      this.onDrawer = true
      return this.onDrawer
    },
  },
}
</script>
